import { useQuery } from '@tanstack/react-query';

const useLocations = () => {
  const { data, isSuccess } = useQuery({
    queryKey: [
      'locations'
    ]
  });

  return {
    locations: isSuccess ? data.data : null,
    hasLocations: isSuccess ? data.data.length > 0 : false
  };
};

export default useLocations;
